import { render, staticRenderFns } from "./ArticleShareRecordList.vue?vue&type=template&id=f49d8b3c&scoped=true"
import script from "./ArticleShareRecordList.vue?vue&type=script&lang=js"
export * from "./ArticleShareRecordList.vue?vue&type=script&lang=js"
import style0 from "./ArticleShareRecordList.vue?vue&type=style&index=0&id=f49d8b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49d8b3c",
  null
  
)

export default component.exports